import { PageTitle as BCPageTitle } from '@britishcouncil/react-registration-platform';
import styled from '@emotion/styled';

export const PageTitle = styled(BCPageTitle)`
  && {
    font-weight: 600;
  }
`;
